import React, { useState, useEffect } from 'react';
import apiServicewt from '../api/apiServicewt';
import { useLanguageSwitch } from '../contexts/LanguageSwitchContext';

const Logo = () => {
	const [logo, setLogo] = useState([]);
	const { setIsLangSwitchEnabled } = useLanguageSwitch();

	useEffect(() => {
		const fetchata = async () => {
			const item = { action: 'get_login_settings' };
			const flechdata = await apiServicewt(item);
			if (flechdata.type === 'Success' || flechdata.type === 'success') {
				setLogo(flechdata.data);
			}
		};

		const fetchLang = async () => {
			const item = { action: 'get_settings' };
			const flechdata = await apiServicewt(item);

			if (flechdata.type === 'Success' || flechdata.type === 'success') {
				setIsLangSwitchEnabled(flechdata.data.userweb_lang_switch === '1');
			}
		};

		fetchLang();
		fetchata();
	}, []);

	return (
		<img
			style={{ width: '160px', height: '40px', objectFit: 'contain', fontSize: '20px' }}
			src={logo.site_logo}
			alt='Site Logo'
		/>
	);
};
Logo.propTypes = {};
Logo.defaultProps = {};

export default Logo;
